import React, { useRef } from 'react';
import AddBoxIcon from '@material-ui/icons/AddBox';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import { IconButton } from '@material-ui/core';

const ColumnCountStock = ({ rowData, handleModifyStock, editingData, changeEditing, handleChange, saveChanges }) => {
    const isEditing = editingData.flag && editingData.reference === rowData.reference;
    const inputCount = useRef(null);

    const changeEditingAction = flag => {
        changeEditing(flag, rowData.reference, rowData.count)

        if (flag) {
            setTimeout(() => {
                inputCount.current.focus()
            }, 300)
        }
    }

    const goUpStock = rowData => {
        let rowDataNew = {...rowData, count: parseInt(rowData.count) + 1}
        handleModifyStock(rowDataNew, rowData)
    }

    const goDownStock = rowData => {
        let rowDataNew = {...rowData, count: parseInt(rowData.count) - 1}
        handleModifyStock(rowDataNew, rowData)
    }

    return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            { isEditing ? 
                <IconButton onClick={() => changeEditing(false)} style={{ color: 'red'}}>
                    <CancelIcon />
                </IconButton> :
                <IconButton onClick={() => goDownStock(rowData)} color='primary'>
                    <IndeterminateCheckBoxIcon />
                </IconButton>
            }
            { isEditing ?
                <input style={{ minWidth: '40px', width: '100%', textAlign: 'center', display: isEditing ? 'initial' : 'none' }} 
                    type="text" name="name" 
                    value={editingData.newValue} 
                    onChange={handleChange}
                    ref={inputCount}
                /> :
                <div style={{ minWidth: '40px', flex: 1, textAlign: 'center'}} onClick={() => changeEditingAction(true)}>{rowData.count}</div>
            }
            { isEditing ?
                <IconButton onClick={() => saveChanges(rowData)} style={{ color: '#01540C' }}>
                    <CheckCircleIcon />
                </IconButton> :
                <IconButton onClick={() => goUpStock(rowData)} color='primary'>
                    <AddBoxIcon />
                </IconButton>
            }
        </div>
    );
}

export default ColumnCountStock